import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../components/layouts/dashboardLayout'
import { Breadcrumb } from 'react-bootstrap';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useSelector, useDispatch } from 'react-redux';
import actions from '../../store/actions';
import ResponsivePagination from 'react-responsive-pagination';
import productApi from '../../api/product';
import moment from 'moment';
import routes from "../../utils/routes";
import UpdateOrder from '../../components/forms/updateOrder';
import toast from 'react-hot-toast';



let Orders = () => {
   let query = useParams();
   const location = useLocation();
   const queryParams = new URLSearchParams(location.search);
   const id = queryParams.get('id');
   const navigation = useNavigate()

   const [show, setShow] = useState(false);
   const [editData, setEditData] = useState({});

   const [currentPage, setCurrentPage] = useState(1);
   let navigate = useNavigate();
   let orders = useSelector(data => data.orders);
   let setting = useSelector(data => data?.profile?.data?.setting);
   let dispatch = useDispatch();
   useEffect(() => {
      setCurrentPage(orders?.page)
      // if (orders?.page != 1) {// to reset the data 
      //    getOrdersList(1);
      // }
   }, [])

   useEffect(() => {
      if (id) {
         let data = orders?.data?.filter(data => data?._id == id);
         if (data?.length > 0) {
            setEditData(data[0])
            setShow(true)
         } else {
            getOrderDetails(id)
         }
      }
   }, [])

   const getOrderDetails = async (orderId) => { //TODO Make get order details api by admin
      try {
         let tostId = toast.loading("Loading....")
         productApi.getOrderDetails(orderId).then(async res => {
            if (res?.data?.error == false) {
               setEditData(res?.data?.data);
               setShow(true);
               toast.success("Order details.", { id: tostId });
               return
            }
            toast.error("No data found.", { id: tostId });
         })
      } catch (error) {
         console.log("brands getting error", error.message)
      }
   }

   const getOrdersList = (page) => {
      try {
         dispatch(actions.ordersLoading());
         productApi.getOrders(page).then(async res => {
            if (res?.data?.data) {
               dispatch(actions.addOrdersList({
                  data: res?.data?.data?.data,
                  page: res?.data?.data?.page,
                  limit: res?.data?.data?.perPage,
                  totalPages: res?.data?.data?.totalPages,
                  total: res?.data?.data?.total
               }));
               setCurrentPage(res?.data?.data?.page)
            }
         })
      } catch (error) {
         console.log("brands getting error", error.message)
      }
   }
   const updateList = async (data) => {
      let ordersList = orders.data;
      const updateIndex = await ordersList.findIndex(object => object._id == data._id);
      ordersList[updateIndex] = data
      dispatch(actions.addOrdersList({
         data: ordersList,
         page: orders.page,
         limit: orders.limit,
         totalPages: orders.totalPages,
         total: orders.total
      }));
      setShow(false)
      dispatch(actions.newOrderRevived(data.status == "PENDING" ? 1 : -1)) //Update total value of pending orders.
   }



   return (
      <>
         <DashboardLayout>
            <div className="container-fluid mt-4">
               <div className="row">
                  <div className="col-12">
                     <Breadcrumb>
                        <Breadcrumb.Item href="#">
                           Dashboard
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>Manage Orders</Breadcrumb.Item>
                     </Breadcrumb>
                  </div>
               </div>
               <div className="row">
                  <div className="col-12">
                     <div className="card p-3 dashboard-card">
                        <div className="card-heading text-muted">Orders ({orders?.total})</div>
                        {orders.loading ? (
                           <div className='pageSimpleLoader'>
                              {orders.loading ? "Loading..." : "No record found"}
                           </div>
                        ) : (
                           <>
                              <div className="table-responsive">
                                 <table className='table'>
                                    <thead>
                                       <tr>
                                          <th>#</th>
                                          <th>Name</th>
                                          <th>Phone</th>
                                          <th>QTY</th>
                                          <th>Cost</th>
                                          <th>Status</th>
                                          <th>Date</th>
                                          <th>Action</th>
                                       </tr>
                                    </thead>
                                    <tbody>
                                       {orders?.data?.map((data, index) => {
                                          const startItemNumber = (currentPage - 1) * 10;
                                          return (
                                             <tr key={index}>
                                                <td>{startItemNumber + index + 1}</td>
                                                <td>{data.name}</td>
                                                <td>{data.phoneNumber}</td>
                                                <td>{data.productsQuantity}</td>
                                                <td>{setting?.currencySymbol} {data.totalCost}</td>
                                                <td>
                                                   {data?.status == "PENDING" && <span className="badge bg-warning">{data?.status}</span>}
                                                   {data?.status == "ACCEPTED" && <span className="badge bg-success">{data?.status}</span>}
                                                   {data?.status == "REJECTED" && <span className="badge bg-danger">{data?.status}</span>}
                                                   {data?.status == "DELIVERED" && <span className="badge bg-success">{data?.status}</span>}
                                                   {data?.status == "RETURNED" && <span className="badge bg-info">{data?.status}</span>}
                                                </td>
                                                <td>{moment(data.createdAt).fromNow()}</td>
                                                <td><button className='btn bg-black text-white text-small'
                                                   onClick={() => {
                                                      setEditData(data);
                                                      setShow(true)
                                                   }}
                                                > <small>View</small> </button></td>
                                             </tr>
                                          )
                                       })}
                                       {orders?.data?.length == 0 && (
                                          <td colSpan={8} className='text-center py-5'>
                                             {orders.loading ? "Loading..." : "No record found"}
                                          </td>
                                       )}
                                    </tbody>
                                 </table>
                              </div>
                              <ResponsivePagination
                                 current={Number(orders?.page)}
                                 total={orders?.totalPages || 0}
                                 onPageChange={getOrdersList}
                              />
                           </>
                        )}
                     </div>
                  </div>
               </div>
            </div>
            <Offcanvas
               // responsive="lg"
               className="container w-100 "
               show={show} placement="end" onHide={() => {
                  if (id) {
                     navigation(-1)
                  } else {
                     setShow(false)
                  }
               }}>
               <Offcanvas.Header closeButton>
                  <Offcanvas.Title>Order Details</Offcanvas.Title>
               </Offcanvas.Header>
               <Offcanvas.Body className='py-0'>
                  <UpdateOrder setting={setting} updateList={updateList} data={editData} />
               </Offcanvas.Body>
            </Offcanvas>
         </DashboardLayout>
      </>
   )
}

export default Orders